<template>
	<div class="contact-information">
		<section>
			<LeadLockup lead="Contact Information">
				<p>
					Returning customer?
					<BButton
						variant="link"
						class="contact-information__login-action p-0"
						@click="showModal = true"
					>Click here to login
					</BButton>
				</p>
			</LeadLockup>

			<EmailForm :has-error="showFormErrors && hasEmailError"/>
		</section>

		<LoginModal
			:show="showModal"
			@close-modal="showModal = false"
			@success="onSuccess"
		/>
	</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import EmailForm from '@component/user-backend/Checkout/V4/forms/EmailForm.vue';
import LeadLockup from '@component/user-backend/Checkout/V4/LeadLockup.vue';
import LoginModal from '@component/user-backend/Checkout/V4/LoginModal.vue';

export default {
	components: {
		EmailForm,
		LeadLockup,
		LoginModal,
	},

	data: () => ({
		showModal: false,
	}),

	computed: {
		...mapState('checkout', ['showFormErrors']),
		...mapGetters('checkout', ['hasEmailError']),
	},

	methods: {
		...mapActions('checkout', ['initialize']),
		async onSuccess() {
			await this.initialize(true);
			this.showModal = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.contact-information {
	display: grid;
	gap: var(--size-xl);

	@media screen and (max-width: 992px) {
		gap: var(--size-lg);
	}

	&__login-action {
		color: var(--blue-500);
	}
}
</style>
